module.exports = __webpack_public_path__ + "img/ls.79261c0.svg";